import { render, staticRenderFns } from "./view-mode-toggle.vue?vue&type=template&id=197088f5&scoped=true&"
import script from "./view-mode-toggle.vue?vue&type=script&lang=js&"
export * from "./view-mode-toggle.vue?vue&type=script&lang=js&"
import style0 from "./view-mode-toggle.vue?vue&type=style&index=0&id=197088f5&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197088f5",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VBtnToggle,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('197088f5')) {
      api.createRecord('197088f5', component.options)
    } else {
      api.reload('197088f5', component.options)
    }
    module.hot.accept("./view-mode-toggle.vue?vue&type=template&id=197088f5&scoped=true&", function () {
      api.rerender('197088f5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/consolidator/components/view-mode-toggle/view-mode-toggle.vue"
export default component.exports